import { z } from 'zod';
export var CaptchaType;
(function (CaptchaType) {
    CaptchaType["RecaptchaEnterprise"] = "RecaptchaEnterprise";
    CaptchaType["Turnstile"] = "Turnstile";
    CaptchaType["Cap"] = "Cap";
    CaptchaType["Geetest"] = "Geetest";
})(CaptchaType || (CaptchaType = {}));
export var RecaptchaEnterpriseMode;
(function (RecaptchaEnterpriseMode) {
    RecaptchaEnterpriseMode["Invisible"] = "invisible";
    RecaptchaEnterpriseMode["Checkbox"] = "checkbox";
})(RecaptchaEnterpriseMode || (RecaptchaEnterpriseMode = {}));
export const turnstileConfigGuard = z.object({
    type: z.literal(CaptchaType.Turnstile),
    siteKey: z.string(),
    secretKey: z.string(),
});
export const recaptchaEnterpriseConfigGuard = z.object({
    type: z.literal(CaptchaType.RecaptchaEnterprise),
    siteKey: z.string(),
    secretKey: z.string(),
    projectId: z.string(),
    domain: z.string().optional(),
    mode: z.nativeEnum(RecaptchaEnterpriseMode).optional(),
    scoreThreshold: z.number().min(0).max(1).optional(),
});
/**
 * Config of a self-hosted Cap Standalone instance.
 *
 * @see https://capjs.js.org/guide/standalone/
 */
export const capConfigGuard = z.object({
    type: z.literal(CaptchaType.Cap),
    /** The public base URL of the Cap Standalone instance, e.g. `https://cap.example.com`. */
    endpoint: z
        .string()
        .url()
        .refine((value) => ['http:', 'https:'].includes(new URL(value).protocol), {
        message: 'The endpoint must be an HTTP(S) URL.',
    }),
    siteKey: z.string(),
    secretKey: z.string(),
});
/**
 * Config of GeeTest CAPTCHA v4.
 *
 * @see https://docs.geetest.com/BehaviorVerification/overview/start
 */
export const geetestConfigGuard = z.object({
    type: z.literal(CaptchaType.Geetest),
    /** The CAPTCHA ID (`captcha_id`) from the GeeTest dashboard. */
    siteKey: z.string(),
    /** The CAPTCHA key (`captcha_key`) from the GeeTest dashboard. */
    secretKey: z.string(),
});
export const captchaConfigGuard = z.discriminatedUnion('type', [
    turnstileConfigGuard,
    recaptchaEnterpriseConfigGuard,
    capConfigGuard,
    geetestConfigGuard,
]);
